// extracted by mini-css-extract-plugin
export default {"overlay":"_t-z","bodyOpen":"au-z","content":"bu-z","header":"cu-z","close":"du-z","closeNoHeading":"eu-z"};